// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import isDate from "lodash/isDate";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {
    dateTime?: Date | null;
    options?: Intl.DateTimeFormatOptions;
}

const mapStateToProps = (state: ApplicationState) => ({
    language: state.context.session.language,
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

/**
 * This component will return a dateTime localized to the language of the session.
 * This component should only be used in cases where the dateTime cannot be generated server side.
 */
const LocalizedDateTime: FC<Props> = ({ dateTime, language, options }) => {
    if (!dateTime) {
        return null;
    }

    let dt = dateTime;
    if (!isDate(dt)) {
        dt = new Date(dt);
    }

    return (
        <>
            {getLocalizedDateTime({
                dateTime: dt,
                language,
                // Xng-Changes: PAC-927
                options: {
                    ...options,
                    day: "2-digit",
                    month: "2-digit",
                    year: options?.year || "numeric"
                },
            })}
        </>
    );
};

export default connect(mapStateToProps)(LocalizedDateTime);
